export { VpHoverInfo } from './VpHoverInfo';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpHoverInfo/index.js